import { z } from 'zod';

import { PERMISSION_LIST } from '../permissions.ts';
import { effectiveAppearanceSchema } from './appearance.ts';

export const signInBodySchema = z.object({
  email: z.email().max(254),
  password: z.string().min(1).max(256),
});

/** What the person must do next after a correct password. */
export const signInResultSchema = z.object({
  next: z.enum(['done', 'two_factor', 'two_factor_enrolment']),
});

export const twoFactorCodeBodySchema = z.object({
  /** Six digits from the authenticator app, or a recovery code. */
  code: z.string().min(6).max(16),
});

export const enrolmentSchema = z.object({
  otpauthUri: z.string(),
  /** For typing into the app when the QR code can't be scanned. */
  secret: z.string(),
});

export const recoveryCodesSchema = z.object({ recoveryCodes: z.array(z.string()) });

export const sessionViewSchema = z.object({
  user: z.object({ id: z.uuid(), email: z.string(), displayName: z.string() }),
  facility: z.object({ id: z.uuid(), name: z.string() }),
  facilities: z.array(z.object({ id: z.uuid(), name: z.string() })),
  permissions: z.array(z.enum(PERMISSION_LIST as [string, ...string[]])),
  twoFactor: z.object({ pending: z.boolean(), enrolled: z.boolean() }),
  /** Minutes of inactivity before the session ends. */
  idleMinutes: z.number().int(),
  /** The theme and mode in effect (ADR 0030), so the app applies them at start. */
  appearance: effectiveAppearanceSchema,
  /** The interface language (plan phase3-portal-feedback-kiswahili §8); English by default. */
  language: z.enum(['en', 'sw']).default('en'),
});

export type SessionView = z.infer<typeof sessionViewSchema>;

export const switchFacilityBodySchema = z.object({ facilityId: z.uuid() });
